import { FC, useState } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { PaginationController } from '../../../../components/pagination-controller/index';
import { EventHooks, useFormat } from '../../../../hooks/index';
import {
  eventFormType,
  EventTypeBackend,
  ShareIssuanceEventItem,
} from '../../../../types/events.types';
import { toMathRound } from '../../../../utils/to-math-round.util';
import { resolveTransactionDisplayDate } from '../../utils/resolve-transaction-display-date.util';
import { CardProps } from './transaction-card-variants.types';
import { TransactionOverviewItem } from './transaction-overview-item';
import { TransactionTitleItem } from './transaction-title-item';

export const ShareIssuance: FC<CardProps> = ({ event, companyId }) => {
  const { format } = useFormat();
  const [currentPage, setCurrentPage] = useState(1);
  const valuationId = event.type === EventTypeBackend.SHARE_ISSUANCE ? event.valuation.id : '';
  const { items, totalPages } = EventHooks.useTransactions<ShareIssuanceEventItem>({
    eventId: valuationId,
    eventType: EventTypeBackend.SHARE_ISSUANCE,
    companyId: companyId,
    currentPage,
  });
  if (event.type !== EventTypeBackend.SHARE_ISSUANCE) return <></>;
  const { type, valuation, sharePrice } = event;

  const roundedSharePrice = toMathRound(sharePrice);
  return (
    <>
      {items.map(({ sharesCount, shareClass, stakeholder, date, reverseVesting }, i) => (
        <div
          className="flex flex-col divide-y divide-gray-100 rounded-md shadow-sm"
          key={i + shareClass.id}
        >
          <TransactionTitleItem
            createdAt={format(
              resolveTransactionDisplayDate({ date, reverseVesting }),
              'dd/MM/yyyy',
            )}
            name={stakeholder?.fullName}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="TRANSACTION_TYPE" />}
            value={<AppFormattedMessage id={eventFormType[type]} />}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="VALUATION_EVENT" />}
            value={valuation?.name}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="SHARE_CLASS" />}
            value={shareClass?.name}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="SHARES_PRICE" />}
            value={roundedSharePrice?.toLocaleString('en-US')}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="NO_OF_SHARES" />}
            value={sharesCount?.toLocaleString('en-US')}
          />
        </div>
      ))}
      <PaginationController
        className="mt-6 shrink-0"
        currentPage={currentPage}
        onClick={setCurrentPage}
        totalPages={totalPages}
      />
    </>
  );
};
